<ng-template #fieldComponent />
@if (description$ | async; as desc) {
<small class="form-text" data-testing-id="maxlength-description">
  {{ desc }}
</small>
}
